var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlert = function SvgAlert(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.832 91.86 75.637 21.351C73.09 17.374 68.738 15 64 15s-9.09 2.374-11.637 6.351L7.168 91.86a13.69 13.69 0 0 0-.468 14.002A13.81 13.81 0 0 0 18.806 113h90.388c5.043 0 9.682-2.735 12.107-7.14a13.69 13.69 0 0 0-.47-14ZM64 101.132c-4.156 0-7.525-3.355-7.525-7.493s3.37-7.492 7.525-7.492 7.525 3.354 7.525 7.492-3.37 7.493-7.525 7.493m10.43-52.065-3.706 24.846c-.546 3.657-3.966 6.182-7.639 5.638a6.72 6.72 0 0 1-5.65-5.553L53.412 49.2c-.937-5.773 3.004-11.21 8.802-12.143 5.799-.933 11.259 2.991 12.196 8.764.176 1.088.17 2.21.02 3.245Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export default ForwardRef;